module.exports = __webpack_public_path__ + "img/5.83f01e8e.jpg";